(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TerrainTypeDetailController', TerrainTypeDetailController);

    TerrainTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TerrainType', 'User'];

    function TerrainTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, TerrainType, User) {
        var vm = this;

        vm.terrainType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:terrainTypeUpdate', function (event, result) {
            vm.terrainType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
